import { graphql } from "../../services/wp.api.service";

const query = `
	query RespondentQuery($id: Int!) {
		respondentBy(respondentId: $id) {
			id: databaseId
			weqProfile: weqProfiles(first: 1) {
			  edges {
				node {
					databaseId
					profileResponses {
						response
						statement_id
					}
					weqProfileAcfFields {
						readInstructions
						profilestatus
					}
					stats {
						cONF
						eMA
						eMA_sub_WTFS
						eMC
						eMC_sub_WTFS
						empathy
						fANG
						fANG_dist
						fANX
						fANX_dist
						fEA
						fEA_dist
						fJO
						fJO_dist
						fLO_dist
						fLO
						fSA
						fSA_dist
						fSHA
						fSHA_dist
						feelings
						feelings_Access
						feelings_Range
						feelings_dist
						hSLO
						hSLO_dist
						hSO
						hSO_dist
						lSHO
						lSHO_dist
						lSLO
						lSLO_dist
						love_Joy_Combined
						negative_Focused
						negative_Focused_dist
						other_Oriented
						other_Oriented_dist
						positive_Focused
						positive_Focused_dist
						self_Oriented
						self_Oriented_dist
						self_Other_Focus_Balance
						thoughts
						thoughts_dist
						wTF_Range
						wTF_Sum
						wants
						wants_dist
					}
					percentiles {
						cONF
						eMA
						eMA_sub_WTFS
						eMC
						eMC_sub_WTFS
						empathy
						fANG
						fANG_dist
						fANX
						fANX_dist
						fEA
						fEA_dist
						fJO
						fJO_dist
						fLO
						fLO_dist
						fSA
						fSA_dist
						fSHA
						fSHA_dist
						feelings
						feelings_Access
						feelings_Range
						feelings_dist
						hSLO
						hSLO_dist
						hSO
						hSO_dist
						lSHO
						lSHO_dist
						lSLO
						lSLO_dist
						love_Joy_Combined
						negative_Focused
						negative_Focused_dist
						other_Oriented
						other_Oriented_dist
						positive_Focused
						positive_Focused_dist
						self_Oriented
						self_Oriented_dist
						self_Other_Focus_Balance
						thoughts
						thoughts_dist
						wTF_Range
						wTF_Sum
						wants
						wants_dist
					}
				}
			  }
			}
			respondentAcfFields {
			  consentprivacy
			  profilecomplete
			  name
			}
		  }
	}
`;

const respondentTransform = (respondent) => ({
	id: respondent.id,
	weqProfile: respondent.weqProfile?.edges
		? {
			...respondent.weqProfile.edges[0].node,
			...respondent.weqProfile.edges[0].node.weqProfileAcfFields
		}
		: null,
	...respondent.respondentAcfFields
});

const respondentQuery = (useQuery, id, options) => useQuery(
	["respondent", id],
	() => graphql({
		query,
		variables: {
			id
		}
	}).
		then((res) => respondentTransform(res.data.data.respondentBy)),
	{
		staleTime: 1000 * 60 * 10,
		...options
	}
);

export default respondentQuery;
